import { render, staticRenderFns } from "./ProjectSelection.vue?vue&type=template&id=5bfc5ebe&scoped=true&"
import script from "./ProjectSelection.vue?vue&type=script&lang=js&"
export * from "./ProjectSelection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSelection.vue?vue&type=style&index=0&id=5bfc5ebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc5ebe",
  null
  
)

export default component.exports